import { FieldGrid } from '../form/FieldGrid';
import { DateField } from '../form/DateField';
import { DerivedStat } from './DerivedStat';
import type { UseIndicationFormResult } from '../../hooks/useIndicationForm';
import { formatNumber } from '../../lib/format';

interface Props {
  form: UseIndicationFormResult;
}

const MS_PER_DAY = 86_400_000;

export function StepTerm({ form }: Props) {
  const { state, setField, markTouched, errors } = form;

  const start = Date.parse(state.startDate);
  const end = Date.parse(state.endDate);
  let days: number | null = null;
  let proRata: number | null = null;
  if (Number.isFinite(start) && Number.isFinite(end) && end > start) {
    days = Math.round((end - start) / MS_PER_DAY);
    proRata = days / 365;
  }

  return (
    <fieldset className="border-0 p-0 m-0">
      <legend className="sr-only">Project term</legend>
      <FieldGrid>
        <div data-field="startDate">
          <DateField
            label="Start Date"
            required
            value={state.startDate}
            onChange={(e) => setField('startDate', e.target.value)}
            onBlur={() => markTouched('startDate')}
            error={errors.startDate}
          />
        </div>
        <div data-field="endDate">
          <DateField
            label="End Date"
            required
            value={state.endDate}
            onChange={(e) => setField('endDate', e.target.value)}
            onBlur={() => markTouched('endDate')}
            error={errors.endDate}
            min={state.startDate || undefined}
          />
        </div>
      </FieldGrid>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        <DerivedStat
          label="Project Days"
          value={days === null ? '···' : formatNumber(days)}
        />
        <DerivedStat
          label="Pro-rata Factor"
          value={proRata === null ? '···' : formatNumber(proRata, 2)}
        />
      </div>
    </fieldset>
  );
}
